import { Box, Grid } from "@mui/material";
import { cloudfrontUrl } from "../../../constants/imageUrl";
import useIsMobile from "../../../hooks/useIsMobile";
import { useState, useEffect, useRef } from "react";

interface NewCardProps {
  title: string;
  image: string;
  url: string;
}

function NewCard({ title, image, url }: NewCardProps) {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        height: "580px",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        },
      }}
      onClick={() => window.open(url, "_blank")}
    >
      {/* Image Container */}
      <Box
        sx={{
          width: "100%",
          height: "420px",
          overflow: "hidden",
          backgroundColor: "#f9fafb",
          flexShrink: 0,
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      {/* Content Container */}
      <Box
        sx={{
          padding: "1.5rem",
          flex: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h3
          style={{
            margin: "0",
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#333",
            lineHeight: "1.3",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {title}
        </h3>
      </Box>
    </Box>
  );
}

const news = [
  {
    title:
      "Cérémonie d’ouverture KSM – Retour sur l’événement du 1er octobre 2025",
    image: `${cloudfrontUrl}/about/news/KoreanStreetMarket_Horangout-20-480x360.jpg `,
    url: "https://horangout.com/korean-street-market-nice/",
  },
  {
    title: "KSM célèbre son ouverture officielle",
    image: `${cloudfrontUrl}/about/news/grand_opening.jpg`,
    url: `https://www.instagram.com/koreanstreetmarket/reel/DQCM9-7iAR_/`,
  },
  {
    title: "En direct d’Instagram",
    image: `${cloudfrontUrl}/about/news/IMG_7242.jpg`,
    url: "https://www.instagram.com/reel/DPgPggoiAtu/?igsh=cHR0b3ZleWplejJq",
  },
];

export default function News() {
  const isMobile = useIsMobile("md");
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={sectionRef} sx={{ width: "100%", height: "100%" }}>
      <style>
        {`
          @keyframes slideInFromTop {
            from {
              opacity: 0;
              transform: translateY(-50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .animate-from-top {
            animation: slideInFromTop 0.8s ease-out forwards;
          }
        `}
      </style>

      <Grid container sx={{ height: "100%" }}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
              padding: "2rem",
            }}
          >
            {/* Main centered image - slides from top */}
            <img
              src={`${cloudfrontUrl}/about/ksmweb_news_banner.png`}
              alt="News Banner"
              className={isVisible ? "animate-from-top" : ""}
              style={{
                width: isMobile ? "100%" : "25%",
                height: "auto",
                opacity: isVisible ? 1 : 0,
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          backgroundColor: "#fff",
          padding: `2rem ${isMobile ? "2" : "20"}rem`,
        }}
      >
        <Grid container spacing={3}>
          {news.map((newItem, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <NewCard {...newItem} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
